import { useEffect, useMemo } from "react";
import { CoverStoryHero, ListCoverStories, SEO, SoundPopup } from "@components";
import { FaustTemplate, useFaustQuery } from "@faustwp/core";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { HIGHLIGHT_COLOR_BY_TYPE, HIGHLIGHT_COLORS } from "@/core/constants";
import { getBasicQueryVars, getLanguageQueryVar, getPageTitle } from "@/core/utils";
import { usePageLoading } from "@/providers/LoadingContext";
import { useTrackRouteChange } from "@/providers/TrackingContext";
import { GetCoverStoriesQuery, GetCoverStoryOptionsQuery, GetCoverStoryPageDataQuery } from "@graphqlTypes";
import { CoverStoriesQuery, CoverStoryLandingQuery, CoverStoryOptionsQuery } from "@/queries/CoverStory";
import { useDebug } from "@/utils/useDebugLog";

const CoverStoryPage: FaustTemplate<any> = ({ pageWrapperData, loading }: FaustPageProps<any>) => {
  const { log } = useDebug({ name: 'page-cover-story', bgColor: '#4ECDC4', enabled: false });

  // Hooks
  const { setHighlightColor } = usePageHighlight();
  const { previewLoading, setPreviewLoading } = usePageLoading();

  // Site settings
  const { siteSettings: { customSettings: { siteTitle }} } = pageWrapperData;

  // Data queries
  const pageData = useFaustQuery<GetCoverStoryPageDataQuery>(CoverStoryLandingQuery);
  const optionsData = useFaustQuery<GetCoverStoryOptionsQuery>(CoverStoryOptionsQuery);

  // Extract page data
  const { title, coverStoryLanding, featuredCoverStory, pageData: { pageCategory, ogTitle, ogDescription, featuredImage } = {} } = pageData?.rhPage || {};
  const [category] = pageCategory || [];
  const { coverStories } = pageData

  // Extract options data
  const { coverStoryOptions: { coverStoryOptions: { coverStoryListHeadline, coverStoryListLabels, soundPopupOverride } = {} } = {} } = optionsData || {};

  // SEO
  const seoTitle = getPageTitle(siteTitle, ogTitle || title);

  // --------------------

  useEffect(() => {
    log({ coverStories });
  }, [coverStories]);

  // Set highlight color based on page category
  useEffect(() => {
    setHighlightColor(HIGHLIGHT_COLOR_BY_TYPE[category?.slug] || HIGHLIGHT_COLORS.GREEN);
  }, [category]);

  // Track route change for analytics
  useTrackRouteChange(category?.slug);

  // Handle preview loading state
  useEffect(() => {
    if (!loading && previewLoading) setPreviewLoading(false);
  }, [loading, previewLoading]);

  // -------------------- Render

  if (loading) return;

  return (
    <>
      <SEO title={seoTitle} description={ogDescription || ""} image={featuredImage} />
      <CoverStoryHero {...coverStoryLanding?.coverStoryHero} latestGame={featuredCoverStory} />
      <ListCoverStories coverStories={coverStories} headline={coverStoryListHeadline} labels={coverStoryListLabels} />
      {/* <SoundPopup headlineOverride={soundPopupOverride} /> No sound for now */}
    </>
  );

};

CoverStoryPage.queries = [
  { query: CoverStoryLandingQuery, variables: getBasicQueryVars },
  { query: CoverStoryOptionsQuery, variables: getLanguageQueryVar },
]

export default CoverStoryPage;
